import { render } from "./CalculadoraDeCarbono.vue?vue&type=template&id=7ba23322"
import script from "./CalculadoraDeCarbono.vue?vue&type=script&lang=js"
export * from "./CalculadoraDeCarbono.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__